import React, { SVGProps } from "react";

const SvgRoof8 = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 350 300" {...props}>
    <path fill="none" d="M0 0h350v300H0z" />
    <g data-name="roof010 dims 1">
      <path
        fill="#bdcddb"
        d="M121.643 183.19v36.598l170.276-98.418V84.772L121.643 183.19z"
      />
      <path
        fill="#fff"
        d="M121.643 183.25v36.538L24.51 163.839v-36.898l97.133 56.309z"
      />
      <path
        fill="#bdcddb"
        d="M211.839 172.462v37.827l63.057-36.515v-45.162l-26.599-3.688-36.458 47.538z"
      />
      <path
        fill="#fff"
        d="M211.839 172.462v37.827l-37.016-21.241v-38.187l37.016 21.601z"
      />
      <path
        fill="#2077aa"
        d="M302.062 79.233 121.98 183.446l-8.449-109.813 89.371-51.534 99.16 57.134z"
      />
      <path
        fill="#48d7ff"
        d="m202.744 22.191-89.213 51.442-98.601 47.754 180.329-104.22 7.485 5.024z"
      />
      <path
        fill="#4cf1ff"
        d="M121.98 183.446 14.93 121.387l98.601-47.754 8.449 109.813z"
      />
      <path
        fill="#45e1ff"
        d="m176.172 151.95 35.603 20.55 36.522-47.576-64.317-37.2-7.808 64.226z"
      />
      <path
        fill="#2682b5"
        d="m249.669 109.553 35.285 20.454-36.657-5.083-64.317-37.2 65.689 21.829z"
      />
      <g fill="none">
        <path
          stroke="#3f3f3f"
          strokeMiterlimit={10}
          d="M211.839 172.462v37.541"
        />
        <path
          stroke="#3f3f3f"
          strokeMiterlimit={10}
          strokeWidth={2}
          d="m280.993 127.686 10.926-6.316V84.772"
        />
        <path
          stroke="#3f3f3f"
          strokeMiterlimit={10}
          d="M174.823 189.048v-36.446"
        />
        <path
          stroke="#3f3f3f"
          strokeMiterlimit={10}
          strokeWidth={2}
          d="M274.896 128.612v45.162l-63.057 36.515-37.016-21.241-53.18 30.74-97.133-55.949v-36.898M278.529 129.122l-3.684 2.121"
        />
        <path
          stroke="#3f3f3f"
          strokeMiterlimit={10}
          d="M121.642 183.19v36.598"
        />
        <path
          stroke="#002839"
          strokeMiterlimit={10}
          d="m113.531 73.633 89.371-51.534"
        />
        <path
          stroke="#002839"
          strokeLinejoin="round"
          d="m176.172 151.95 7.808-64.226 64.022 37.029M183.98 87.724l65.689 21.829M121.981 183.446l-8.45-109.813-98.601 47.754"
        />
        <path
          stroke="#002839"
          strokeLinejoin="round"
          strokeWidth={2}
          d="m249.669 109.553 35.285 20.454-36.952-5.254-36.163 47.709-35.667-20.512-54.191 31.496L14.93 121.387l180.33-104.22 7.642 4.932 99.16 57.134-52.393 30.32z"
        />
      </g>
      <g
        fill="none"
        stroke="#3b3b3b"
        strokeLinecap="round"
        strokeMiterlimit={10}
        strokeWidth={1.5}
      >
        <path d="m99.507 232.484 17.095-9.882M2.635 176.675l17.055-9.919M6.85 174.293l133.856 77.163" />
      </g>
      <g
        fill="none"
        stroke="#3b3b3b"
        strokeLinecap="round"
        strokeMiterlimit={10}
        strokeWidth={1.5}
      >
        <path d="m162.708 238.727 44.541-25.723M136.518 253.852l17.608-10.169" />
      </g>
      <g
        fill="none"
        stroke="#3b3b3b"
        strokeLinecap="round"
        strokeMiterlimit={10}
        strokeWidth={1.5}
      >
        <path d="m230.127 220.745-14.021-8.106M293.335 184.372l-14.026-8.171" />
      </g>
      <g
        fill="none"
        stroke="#3b3b3b"
        strokeLinecap="round"
        strokeMiterlimit={10}
        strokeWidth={1.5}
      >
        <path d="m176.494 251.467-49.046-28.328M342.788 150.763l-170.462 98.296" />
      </g>
      <g
        fill="none"
        stroke="#3b3b3b"
        strokeLinecap="round"
        strokeMiterlimit={10}
        strokeWidth={1.5}
      >
        <path d="M347.021 153.014 304.408 128.4M297.148 124.219l-2.24-1.304" />
      </g>
      <text
        transform="translate(199.88 245.883)"
        fontSize={16}
        fill="#3b3b3b"
        fontFamily="'Effra Regular', Effra"
      >
        {"C"}
      </text>
      <text
        transform="translate(64.39 121.878)"
        fontSize={16}
        fontFamily="'Effra Regular', Effra"
      >
        {"P1"}
      </text>
      <text
        transform="translate(308.36 121.218)"
        fontSize={16}
        fill="#3b3b3b"
        fontFamily="'Effra Regular', Effra"
      >
        {"P3"}
      </text>
      <text
        transform="translate(150.205 123.21)"
        fontSize={16}
        fill="#fff"
        fontFamily="'Effra Regular', Effra"
      >
        {"P2"}
      </text>
      <text
        transform="translate(259.623 212.878)"
        fontSize={16}
        fill="#3b3b3b"
        fontFamily="'Effra Regular', Effra"
      >
        {"D"}
      </text>
      <text
        transform="translate(316.313 179.612)"
        fontSize={16}
        fill="#3b3b3b"
        fontFamily="'Effra Regular', Effra"
      >
        {"E"}
      </text>
      <text
        transform="translate(112.086 253.94)"
        fontSize={16}
        fill="#3b3b3b"
        fontFamily="'Effra Regular', Effra"
      >
        {"B"}
      </text>
      <text
        transform="translate(46.025 215.869)"
        fontSize={16}
        fill="#3b3b3b"
        fontFamily="'Effra Regular', Effra"
      >
        {"A"}
      </text>
      <path
        fill="none"
        stroke="#3b3b3b"
        strokeLinecap="round"
        strokeMiterlimit={10}
        strokeWidth={1.5}
        d="M6.791 170.375v7.769M103.631 226.285v7.77M140.686 247.679v7.769M172.325 245.182v7.769M225.742 214.342v7.769M288.954 177.846v7.77M343.037 146.622v7.769M310.811 91.211l-54.306 31.234M309.719 95.306l-6.728-3.885M299.523 135.261l-2.018-7.503M298.63 131.58c5.256-12.844 8.2-26.06 8.094-38.084M302.707 132.007l-12.863-1.71"
      />
      <path
        d="M173.43 108.863a71.97 71.97 0 0 1-.574 8.894c-1.626 12.59-6.546 21.796-13.695 27.31"
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeMiterlimit={10}
        strokeWidth={1.5}
      />
      <path
        d="M59.684 104.628a65.408 65.408 0 0 0 .517 8.779c1.638 12.672 6.979 21.538 14.687 26.21"
        fill="none"
        stroke="#000"
        strokeLinecap="round"
        strokeMiterlimit={10}
        strokeWidth={1.5}
      />
      <path
        fill="none"
        stroke="#fff"
        strokeMiterlimit={10}
        strokeDasharray={6}
        opacity={0.5}
        d="m167.014 157.336-53.483-83.703"
      />
      <path
        fill="none"
        stroke="#002839"
        strokeMiterlimit={10}
        strokeDasharray={6}
        opacity={0.5}
        d="m67.402 152.369 46.129-78.736"
      />
      <path
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeMiterlimit={10}
        strokeWidth={1.5}
        d="M178.347 111.747 119.02 77.241"
      />
      <path
        fill="none"
        stroke="#000"
        strokeLinecap="round"
        strokeMiterlimit={10}
        strokeWidth={1.5}
        d="m54.324 107.762 50.55-29.121M63.169 106.849l-6.728-3.885M71.489 141.261l6.729-3.885"
      />
      <path
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeMiterlimit={10}
        strokeWidth={1.5}
        d="m162.516 146.901-6.728-3.884M176.809 107.241l-6.728 3.885"
      />
    </g>
  </svg>
);

export default SvgRoof8;
